import React from 'react';
import Skills from '../layouts/Skills';
import { about, skillsBar, section2title, education, certifications, interests } from '../../profile';

const About = () => {
    return (
        <div id="about" className="effect2">
            <div data-aos="zoom-in-up" data-aos-once="true" className="row">
                <div className="col-12 d-none d-md-block offset-md-1 col-md-4 Photo" id="not"></div>
                <div className="col-12 offset-md-1 col-md-6 about">
                    <div className="About-title-box">
                        <h1 id="About" className="red-line">{section2title}</h1>
                    </div>
                    <p className="lead about-text">{about.paragraph}</p>

                    <div className="about-text" style={{ marginTop: '1.5rem' }}>
                        <h5 style={{ color: 'var(--primary-color)', fontWeight: 700, marginBottom: '0.3rem' }}>
                            Education
                        </h5>
                        <p style={{ marginBottom: '0.2rem' }}>
                            <strong>{education.institution}</strong>
                        </p>
                        <p style={{ marginBottom: '0.2rem' }}>
                            {education.degree},{' '}
                            <span style={{ color: 'var(--primary-color)', fontWeight: 600 }}>
                                {education.grade}
                            </span>
                        </p>
                        <p style={{ color: '#777', fontSize: '0.9rem' }}>{education.period}</p>
                    </div>

                    {certifications && certifications.length > 0 && (
                        <div className="about-text" style={{ marginTop: '1rem' }}>
                            <h5 style={{ color: 'var(--primary-color)', fontWeight: 700, marginBottom: '0.4rem' }}>
                                Certifications
                            </h5>
                            {certifications.map((cert, i) => (
                                <p key={i} style={{ marginBottom: '0.2rem' }}>
                                    <i className="fas fa-certificate" style={{ color: 'var(--primary-color)', marginRight: '0.5rem' }}></i>
                                    {cert}
                                </p>
                            ))}
                        </div>
                    )}

                    {interests && interests.length > 0 && (
                        <div className="about-text" style={{ marginTop: '1rem' }}>
                            <h5 style={{ color: 'var(--primary-color)', fontWeight: 700, marginBottom: '0.5rem' }}>
                                Interests
                            </h5>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                                {interests.map((item, i) => (
                                    <span
                                        key={i}
                                        style={{
                                            background: 'rgba(233,98,36,0.1)',
                                            color: 'var(--primary-color)',
                                            border: '1px solid rgba(233,98,36,0.3)',
                                            borderRadius: '1rem',
                                            padding: '0.2rem 0.7rem',
                                            fontSize: '0.85rem',
                                            fontWeight: 600,
                                        }}
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div id="Skills">
                <div className="row d-flex justify-content-center skills">
                    {skillsBar.map((x, i) => (
                        <Skills key={i} faClass={x.faClass} label={x.name} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default About;
